import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetDepartmentDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Department/GetDetail?` + params, null);

export const GetDepartmentList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Department/GetList?` + params, null);

export const CreateDepartment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Department/Create`, data);

export const UpdateDepartment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Department/Update`, data);    

export const DeleteDepartment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Department/Delete`, data);






